import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddToPantryModal from '../../components/AddToPantryModal';
import axios from 'axios';
import { useToken } from '../../auth/useToken';
import { useUser } from '../../auth/useUser';
import TopMenuBar from '../../components/TopMenuBar';
import LeftSidebar from '../../components/LeftSidebar';
import './Pantry.css';

const pantryItems = [
    { id: 1, name: 'Apples', image: 'apple.jpg', expiration: '2024-12-20', quantity: '5 lbs' },
    { id: 2, name: 'Bread', image: 'bread.jpg', expiration: '2024-12-15', quantity: '2 loaves' },
    { id: 3, name: 'Milk', image: 'milk.jpg', expiration: '2024-12-18', quantity: '1 gallon' },
    { id: 4, name: 'Eggs', image: 'eggs.jpg', expiration: '2024-12-25', quantity: '12 pcs' },
    { id: 5, name: 'Carrots', image: 'carrots.jpg', expiration: '2024-12-30', quantity: '2 lbs' },
    { id: 6, name: 'Cheese', image: 'cheese.jpg', expiration: '2024-12-22', quantity: '1 lb' },
    { id: 7, name: 'Yogurt', image: 'yogurt.jpg', expiration: '2024-12-19', quantity: '6 cups' },
    { id: 8, name: 'Chicken', image: 'chicken.jpg', expiration: '2024-12-27', quantity: '3 lbs' },
    { id: 9, name: 'Rice', image: 'rice.jpg', expiration: '2025-01-10', quantity: '10 lbs' },
    { id: 10, name: 'Potatoes', image: 'potatoes.jpg', expiration: '2025-01-05', quantity: '5 lbs' }
];

const getExpiringSoon = (items) => {
    const today = new Date();   
    const nextWeek = new Date();
    nextWeek.setDate(today.getDate() + 7);

    return items.filter(item => {
        const expirationDate = new Date(item.expiration);
        return expirationDate >= today && expirationDate <= nextWeek;
    });
};

export const Pantry = () => {
    const user = useUser();
    const [token, setToken] = useToken();
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState(null);

    const [pantry, setPantry] = useState(pantryItems);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    const { id, email, info } = user || {};

    const handleAddItem = (newItem) => {
        setPantry((prev) => [...prev, newItem]);
    };

    const handleBarcodeScanned = (barcode) => {
        setScannedBarcode(barcode);
        console.log("Scanned Barcode:", barcode);
        // Optionally, fetch item details using the barcode
    };

    const expiringSoonItems = getExpiringSoon(pantry);

    const verifiedAccount = async () => {
        try {
          const response = await axios.get(`/api/users/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const { isverified, phone_number, first_name, last_name } = response.data.user;
          setFirstName(first_name);
    
        } catch (e) {
          console.error('Error response:', e.response);
          setShowErrorMessage(true);
        }
    };

    useEffect(() => {
        if (user) {
            verifiedAccount();
        }
    }, [user]);

    return (
        <>
        <TopMenuBar user={firstName} />
        <LeftSidebar />
        <div className="pantry-container">
            <div className="pantry-main">
                <div className="pantry-header">
                    <h1>Pantry</h1>
                    <h4>{pantry.length} items</h4>
                    <button onClick={() => setIsModalOpen(true)}>Add to Pantry</button>
                </div>
                <hr />
                <div className="pantry-items">
                    {pantry.map((item) => (
                        <div key={item.id} className="pantry-item">
                            <img src={item.image} alt={item.name} className="pantry-image" />
                            <div className="pantry-info">
                                <h3>{item.name}</h3>
                                <p>Expires: {item.expiration}</p>
                            </div>
                            <p className="pantry-quantity">{item.quantity}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="expiring-soon">
                <h2>Expiring Soon</h2>
                <ul>
                    {expiringSoonItems.map((item) => (
                        <li key={item.id} className="expiring-item">
                            <strong>{item.name}</strong> - Expires: {item.expiration}
                        </li>
                    ))}
                </ul>
            </div>
            {isModalOpen && (
                <AddToPantryModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onAddItem={handleAddItem}
                    onBarcodeScanned={handleBarcodeScanned}
                />
            )}
        </div>
        </>
    );
};
